import { render, staticRenderFns } from "./header_2.vue?vue&type=template&id=16a14db1&scoped=true"
import script from "./header_2.vue?vue&type=script&lang=js"
export * from "./header_2.vue?vue&type=script&lang=js"
import style0 from "./header_2.vue?vue&type=style&index=0&id=16a14db1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a14db1",
  null
  
)

export default component.exports